import React from 'react';
import {Route, Routes} from "react-router-dom";
import AuthMain from "../../stream/authentication/AuthMain";
import HomePage from "./HomePage";
import {ErrorBoundary} from "react-error-boundary";
import ErrorPage from "./ErrorPage";
import BookingMain from "../../stream/booking/BookingMain";
import OperationMain from "../../stream/operation/OperationMain";
import NetworkMain from "../../stream/network/NetworkMain";
import PricingMain from "../../stream/pricing/PricingMain";
import AccountsMain from "../../stream/accounts/AccountsMain";
import FinanceMain from "../../stream/finance/FinanceMain";
import OperatorMain from "../../stream/operator/OperatorMain";
import SalesMarketingMain from "../../stream/sales_marketing/SalesMarketingMain";
import CustomerBaseMain from "../../stream/customerbase/CustomerBaseMain";
import FinesSecurityMain from "../../stream/finessecurity/FinesSecurityMain";
import MobilityVoucherMain from "../../stream/mobilityvoucher/MobilityVoucherMain";
import SessionExpiredPage from "../../stream/authentication/page/SessionExpiredPage";
import AdfsLoginPage from "../../stream/authentication/page/AdfsLoginPage";
import LoginPage from "../../stream/authentication/page/LoginPage";
import VerifyCode from "../../stream/authentication/page/VerifyCode";
import ExternalHomePage from "./ExternalHomePage";
import ExternalNetworkMain from "../../stream/network/ExternalNetworkMain";
import PageNotFound from "./PageNotFound";
import {logErrorToBe, useAxiosDefaultConfig} from "../../config/globalConfig";
import NotAuthorizedPage from "./NotAuthorizedPage";
import RecoveryMain from "../../stream/recovery/RecoveryMain";
import AvailabilityReport from '../../stream/operation/component/availability/component/AvailabilityReport';
import AvailabilityReportOld from '../../stream/operation/component/availability/component/AvailabilityReportOld';
import ExpiredManagementMain from "../../stream/expired-management/ExpiredManagementMain";

const RouteContainer = () => {
    useAxiosDefaultConfig();

    const pathOrigin = window.location.origin;
    // @ts-ignore
    let isAdfsEnabled = JSON.parse(window?.appConfig?.ADFS_ENABLED.toLowerCase());

    const FallbackComponent = ({error}:any) => {
        logErrorToBe(error);
        return <ErrorPage/>;
    }

    return (
        <Routes>
            <Route path="/" element={
                <AuthMain>
                    <HomePage/>
                </AuthMain>
            }>
                <Route path="booking/*"
                       element={<ErrorBoundary
                           FallbackComponent={FallbackComponent}><BookingMain/></ErrorBoundary>}/>
                <Route path="operation/*" element={<ErrorBoundary
                        FallbackComponent={FallbackComponent}><OperationMain/></ErrorBoundary>}/>
                <Route path="network/*"
                       element={<ErrorBoundary
                           FallbackComponent={FallbackComponent}><NetworkMain/></ErrorBoundary>}/>
                <Route path="pricing/*"
                       element={<ErrorBoundary
                           FallbackComponent={FallbackComponent}><PricingMain/></ErrorBoundary>}/>
                <Route path="corporate-idp/*" element={<ErrorBoundary
                        FallbackComponent={FallbackComponent}><AccountsMain/></ErrorBoundary>}/>

                <Route path="finance/*"
                       element={<ErrorBoundary
                           FallbackComponent={FallbackComponent}><FinanceMain/></ErrorBoundary>}/>
                <Route path="operator/*"
                       element={<ErrorBoundary
                           FallbackComponent={FallbackComponent}><OperatorMain/></ErrorBoundary>}/>
                <Route path="salesmarketing/*" element={<ErrorBoundary
                        FallbackComponent={FallbackComponent}><SalesMarketingMain/></ErrorBoundary>}/>
                <Route path="mobility-store/*"
                       element={<ErrorBoundary
                           FallbackComponent={FallbackComponent}><NetworkMain/></ErrorBoundary>}/>
                <Route path="customerbase/*"
                       element={<ErrorBoundary
                           FallbackComponent={FallbackComponent}><CustomerBaseMain/></ErrorBoundary>}/>
                <Route path="finessecurity/*"
                       element={<ErrorBoundary
                           FallbackComponent={FallbackComponent}><FinesSecurityMain/></ErrorBoundary>}/>
                <Route path="mobilityvoucher/*" element={<ErrorBoundary
                        FallbackComponent={FallbackComponent}><MobilityVoucherMain/></ErrorBoundary>}/>
                <Route path="recovery/*" element={<ErrorBoundary
                           FallbackComponent={FallbackComponent}><RecoveryMain/></ErrorBoundary>}/>
                <Route path="expired-management/*" element={<ErrorBoundary
                            FallbackComponent={FallbackComponent}><ExpiredManagementMain/></ErrorBoundary>} />
                <Route path="sessionExpired" element={<ErrorBoundary
                        FallbackComponent={FallbackComponent}><SessionExpiredPage/></ErrorBoundary>}/>
            </Route>
            {/*// @ts-ignore*/}
            <Route path="login" element={(isAdfsEnabled && (pathOrigin === `${window?.appConfig?.ADFS_ORIGIN}` || pathOrigin === `${window?.appConfig?.ADFS_INTRA_ORIGIN}`)) ?
                <AdfsLoginPage/> : <LoginPage/>}/>
            <Route path="verify-code" element={<VerifyCode status={'verify'}/>}/>
            <Route path="external" element={
                <ExternalHomePage/>
            }>
                <Route path="network/*" element={
                    <ErrorBoundary FallbackComponent={FallbackComponent}>
                        <ExternalNetworkMain/>
                    </ErrorBoundary>}/>
            </Route>
            <Route path="not-authorized" element={<NotAuthorizedPage/>}/>
            <Route path="*" element={<PageNotFound/>}/>
        </Routes>
    );
};

export default RouteContainer;
